export enum EProcessStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
  Waiting = 10,
  Complete = 1000,
  Canceled = 1001
}

export const EProcessStatusMapping: Record<EProcessStatus, string> = {
  [EProcessStatus.Pending]: 'Pending',
  [EProcessStatus.Approved]: 'Approved',
  [EProcessStatus.Rejected]: 'Rejected',
  [EProcessStatus.Waiting]: 'Waiting',
  [EProcessStatus.Complete]: 'Complete',
  [EProcessStatus.Canceled]: 'Canceled'
};

export const EProcessStatusFinal: EProcessStatus[] = [
  EProcessStatus.Approved,
  EProcessStatus.Complete,
  EProcessStatus.Canceled,
  EProcessStatus.Rejected
];
export const EProcessStatusActiveFinal: EProcessStatus[] = [
  EProcessStatus.Approved,
  EProcessStatus.Complete,
  EProcessStatus.Rejected];
